export const disableAnalyticsCookie = 'ANALYTICS_OPT_OUT';
